/* eslint-disable no-undef */
export const REACT_APP_POOL_TIME = process.env.REACT_APP_POOL_TIME;
export const REACT_APP_POOL_TIME_2 = process.env.REACT_APP_POOL_TIME_2;
export const REACT_APP_URL = process.env.REACT_APP_URL;
export const VERSION = process.env.REACT_APP_VERSION;
